class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    // Title is the toggle control. Prefer a real <button> (now wrapped inside a heading).
    // Fall back to the legacy heading-as-button selector.
    const title =
      this.querySelector(":scope > * > button.collapsible__title") ||
      this.querySelector(":scope > button.collapsible__title") ||
      this.querySelector(":scope > .collapsible__title");

    const content = this.querySelector(":scope > .collapsible__content");

    if (!title || !content) return;

    const setHeightToAuto = () => {
      if (
        content.style.height !== "0px" &&
        title.getAttribute("active") === "true"
      ) {
        content.style.height = "auto";
      }
    };

    const updateHeightForClose = () => {
      const currentHeight = content.scrollHeight + "px";
      content.style.height = currentHeight;
      content.offsetHeight;
      content.style.height = "0px";
    };

    const updateHeight = () => {
      if (title.getAttribute("active") === "true") {
        const prevHeight = content.style.height;
        content.style.height = "auto";
        const newScrollHeight = `${content.scrollHeight}px`;
        content.style.height = prevHeight;

        requestAnimationFrame(() => {
          content.style.height = newScrollHeight;
          content.addEventListener("transitionend", setHeightToAuto, {
            once: true,
          });
        });
      } else {
        updateHeightForClose();
      }
    };

    const syncAria = (active) => {
      // Only set aria-expanded on a real button to avoid invalid ARIA on
      // non-button elements (legacy markup support).
      if (title.tagName === "BUTTON" || title.getAttribute("role") === "button") {
        title.setAttribute("aria-expanded", active ? "true" : "false");
      }
    };

    if (title && title.getAttribute("active") === "true") {
      syncAria(true);
      updateHeight();
    } else {
      title?.setAttribute("active", "false");
      syncAria(false);
    }

    title?.addEventListener("click", function (event) {
      // For real <button>, default behaviour is correct. For legacy heading,
      // ensure it doesn't accidentally submit a form, etc.
      if (title.tagName !== "BUTTON") {
        event.preventDefault();
      }

      const isActive = title.getAttribute("active") === "true";
      title.setAttribute("active", String(!isActive));
      content.setAttribute("active", String(!isActive));
      syncAria(!isActive);

      if (isActive) {
        if (title.classList.contains("read-more-link")) {
          title.innerHTML = title.dataset.readMore;
        }
      } else {
        if (title.classList.contains("read-more-link")) {
          title.innerHTML = title.dataset.readLess;
        }
      }
      updateHeight();
    });

    // Keyboard activation for legacy non-button title elements (Enter / Space)
    if (title.tagName !== "BUTTON") {
      title?.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
          event.preventDefault();
          title.click();
        }
      });
    }

    window.addEventListener("resize", () => {
      if (title.getAttribute("active") === "true") {
        content.style.height = "auto";
        requestAnimationFrame(() => {
          const newScrollHeight = `${content.scrollHeight}px`;
          content.style.height = newScrollHeight;
        });
      }
    });
  }
}

customElements.define("collapsible-element", CollapsibleElement);
